import api from './utilBackoffice';

const controller = 'ModalidadeOperacao';
const url = process.env.VUE_APP_ROOT_API + controller;

export default Object.assign({}, api.GetCrud(controller, null), {
  Listar: dto => {
    return api.Axios.GetParams(url, dto);
  },
  Post: dto => {
    return api.Axios.Post(url, dto);
  },
  Update: dto => {
    return api.Axios.PutCommand(url, dto);
  },
  Deletar: dto => {
    return api.Axios.DeleteCommand(url, dto);
  }
});
